export default function HowIsItUsed(productname) {
    switch(productname){
    case'IndexUniversalLife':
    return {
        title: "How is it Used?",
        content:'IUL protects your clients and their family against life’s unknowns while providing ongoing access to cash value when they need it.'
    }
    case 'VariableUniversalLife':
        return {
            title: "How is it Used?",
            content:'Variable Universal Life insurance protects your clients and their family against life’s unknowns while allowing them to participate in potential market growth and providing ongoing access to cash value when they need it.'
        }
    case 'UniversalLife':
        return {
            title: "How is it Used?",
            content:'Universal Life insurance protects your clients and their family against life’s unknowns while providing ongoing access to cash value when they need it.'
        }
    case 'Wholelife':
        return {
        title: "How is it Used?",
        content:'Whole life protects your clients and their family against life’s unknowns while providing ongoing access to cash value.'
        }
    default:
        return;
 }
}



    



// WEBPACK FOOTER //
// ./src/components/Common/data/products/perm/HowIsItUsed.js